(function () {
  "use strict";

  var productContainerSelector = "product-list.product-list";
  var paginationSelector = ".pagination";
  var triggerSelector = "#infinite-scroll-trigger";
  var loadingSelector = ".infinite-scroll-loading";

  var isLoading = false;
  var observer = null;
  var loadedUrls = new Set();

  function getProductContainer(context) {
    return (context || document).querySelector(productContainerSelector);
  }

  function getPagination(context) {
    return (context || document).querySelector(paginationSelector);
  }

  function getNextPageUrl(context) {
    var pagination = getPagination(context);
    if (!pagination) return null;

    var nextLink =
      pagination.querySelector('a[rel="next"]') ||
      pagination.querySelector('a[href*="page="]:last-of-type');

    if (!nextLink || !nextLink.href) return null;

    return nextLink.href;
  }

  function showLoading(show) {
    var loader = document.querySelector(loadingSelector);
    if (loader) {
      loader.style.display = show ? "inline-block" : "none";
    }
  }

  function stopObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    var trigger = document.querySelector(triggerSelector);
    if (trigger) {
      trigger.style.display = "none";
    }
  }

  function loadNextPage() {
    if (isLoading) return;

    var nextPageUrl = getNextPageUrl(document);

    if (!nextPageUrl) {
      stopObserver();
      return;
    }

    if (loadedUrls.has(nextPageUrl)) return;

    isLoading = true;
    loadedUrls.add(nextPageUrl);
    showLoading(true);

    fetch(nextPageUrl, {
      method: "GET",
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Sayfa yüklenemedi: " + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        var currentContainer = getProductContainer(document);
        var newContainer = getProductContainer(doc);

        if (!currentContainer || !newContainer) {
          stopObserver();
          return;
        }

        currentContainer.insertAdjacentHTML("beforeend", newContainer.innerHTML);

        var currentPagination = getPagination(document);
        var newPagination = getPagination(doc);

        if (currentPagination && newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        } else if (currentPagination) {
          currentPagination.innerHTML = "";
        }

        var hasNextPage = getNextPageUrl(document);

        if (!hasNextPage) {
          stopObserver();
        }
      })
      .catch(function (error) {
        console.error("Infinite scroll hata:", error);
      })
      .finally(function () {
        isLoading = false;
        showLoading(false);
      });
  }

  function initInfiniteScroll() {
    var trigger = document.querySelector(triggerSelector);
    var productContainer = getProductContainer(document);

    if (!trigger || !productContainer) return;

    if (!getNextPageUrl(document)) {
      stopObserver();
      return;
    }

    if (!("IntersectionObserver" in window)) {
      trigger.style.display = "block";
      trigger.innerHTML = '<button type="button" id="load-more-fallback" class="button">Daha Fazla Göster</button>';

      var fallbackButton = document.getElementById("load-more-fallback");
      if (fallbackButton) {
        fallbackButton.addEventListener("click", loadNextPage);
      }

      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      {
        root: null,
        rootMargin: "700px 0px 700px 0px",
        threshold: 0
      }
    );

    observer.observe(trigger);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }
})();